module.exports = __webpack_public_path__ + "static/media/greencircle@2x.086e2502.png";